import { Box, Button, Divider, Modal, MultiSelect, Select, Text } from "@mantine/core";
import { getAlteredCities } from "pages/master/products/helperFunctions";
import { products_api } from "pages/master/products/products.service";
import PropTypes from "prop-types";
import { useDebouncedValue } from "@mantine/hooks";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useEffect, useRef, useState } from "react";
import { showErrorToast, showSuccessToast } from "utilities/Toast";
import { openDeleteConfirmation } from "utilities/utility";

import { stock_apis } from "./stock-transfer.service";

// import CounterUsersList from "./CounterUsersList";
// import { counters_api } from "./counter.service";

function SelectProductModal({ opened, onClose, handleAddProduct, fromCounterId, returnMaster = false }) {
  const queryClient = useQueryClient();

  const [data, setData] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedBatch, setselectedBatch] = useState();

  const [productId, setProductId] = useState(null);
  const [batchFocus, setBatchFocus] = useState(false);
  const [batches, setBatches] = useState([]);
  const buttonRef = useRef();
  const batchRef = useRef();

  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearch] = useDebouncedValue(searchValue, 300);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  // const orders_data = useQuery("orders", order_api.get);
  const products = useQuery({
    queryKey: ["stock-product-data", debouncedSearch, page, fromCounterId, returnMaster],
    onSuccess: res => {
      const content = res.data || [];
      if (res.count !== undefined) {
        setTotalCount(res.count);
      }
      
      const newOptions = content.map(e => ({ value: e.id, label: e.title, rawData: e }));
      
      if (page === 1) {
        setData(newOptions);
      } else {
        setData(prev => {
          const map = new Map(prev.map(i => [i.value, i]));
          newOptions.forEach(i => map.set(i.value, i));
          return Array.from(map.values());
        });
      }
    },
    queryFn: () => stock_apis.get_products_paginated(debouncedSearch, page, 50, fromCounterId, returnMaster),
    keepPreviousData: true,
  });

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    if (opened) {
      setProductId(null);
      setSelectedProduct(null);
      setselectedBatch(undefined);
      setBatches([]);
      setBatchFocus(false);
      setSearchValue("");
    }
  }, [opened]);

  const getProduct = () => {
    console.log(data);
  };

  const handleSelectProduct = id => {
    setProductId(id);
    setselectedBatch(undefined);

    if (!id) {
      setSelectedProduct(null);
      setBatches([]);
      setBatchFocus(false);
      return;
    }

    let item = data.find(e => e.value === id);
    if (!item) {
      setSelectedProduct(null);
      setBatches([]);
      return;
    }
    let product = item.rawData;
    setSelectedProduct(product);

    console.log(product);

    setBatches(
      (product.batch || []).map(e => {
        const expirationDate = new Date(e.exp_date);
        const currentDate = new Date();
        const timeDifference = expirationDate.getTime() - currentDate.getTime();
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
        console.log(e, daysDifference);
        
        const datePlural = (daysDifference > 1) ? ' days' : ' day'
        const isDecimalUnit = !["PCS", "NOS"].includes(product.units?.toUpperCase());
        const formattedStock = isDecimalUnit 
          ? parseFloat(Number(e.stock).toFixed(3)) 
          : Number(e.stock).toFixed(0);
        const stockStr = ` (Stock: ${formattedStock})`;
        const expInfo = (daysDifference > 0) ? ` (${daysDifference}${datePlural} to expire)` : ' (expired)';
        const label = e.batch_no + stockStr + expInfo;

        return {
          label: label,
          value: e.id,
          stock: e.stock,
        };
      })
    );

    // handleAddProduct(product);
  };

  const handleSelectBatch = id => {
    // setselectedBatch();
    let batch = batches.find(e => e.value === id);
    setselectedBatch(batch);
  };

  const handleAddProductChild = () => {
    console.log("Selected product", selectedProduct);
    console.log("Selected batch", selectedBatch);

    const final = {
      ...selectedProduct,
      batch: selectedBatch,
      stock_qty: selectedBatch.stock
    };

    console.log(final);

    if (selectedProduct && selectedBatch) {
      handleAddProduct(final);
      onClose();
      setBatchFocus(false);
    } else {
      showErrorToast({ title: "Error", message: "Please enter product & batch both!" });
    }
  };

  return (
    <div>
      <Modal
        opened={opened}
        onClose={onClose}
        title={
          <Box px={10}>
            <Text fw={600}> Select Product </Text>
          </Box>
        }
        size={"800px"}
        centered
        autoFocus={false}
      >
        <Box px={10} mb={20}>
          <Divider mb={20} />
          <Box>
            <Box>
              <Select
                data-autofocus
                label="Select Product"
                value={productId}
                data={data || []}
                placeholder="Search products.."
                searchable
                searchValue={searchValue}
                onSearchChange={setSearchValue}
                filter={(value, item) => true} // let backend handle search
                withinPortal
                clearable
                onChange={id => {
                  handleSelectProduct(id);
                  if (id) {
                    setBatchFocus(true);
                  } else {
                    setBatchFocus(false);
                  }
                }}
              />
              {batchFocus && (
                <Select
                  autoFocus
                  ref={batchRef}
                  label="Select Batch"
                  value={selectedBatch ? selectedBatch.value : null}
                  mt={10}
                  data={batches || []}
                  placeholder="Select Batch"
                  onChange={id => {
                    handleSelectBatch(id);
                    // console.log("child", id);
                  }}
                  onKeyDown={e => {
                    if (e.key === "Enter" && selectedBatch!==undefined) {
                      buttonRef.current.focus();
                      
                    }
                  }}
                  searchable
                  clearable
                  withinPortal
                />
              )}

              <Button ref={buttonRef} w={"100%"} mt={10} onClick={handleAddProductChild}>
                Add Product
              </Button>
            </Box>
          </Box>
          {/* <CounterUsersList data={data.counter_user} onUnassignUser={onClose}> */}
        </Box>
      </Modal>
    </div>
  );
}

SelectProductModal.propTypes = {
  opened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  editData: PropTypes.object,
};

export default SelectProductModal;
